export default __webpack_public_path__ + "static/media/Ies_panel_PedroMartin.8c4ff9f8.png";